import React from "react";
import { QuestionType } from "../../../service/service";
import { ExamListItem, ExamPaperListItem } from "../../../service/exam";
import { OrderTopicType } from ".";

export interface PaperContextProps {
    paperId: string; //试卷id
    setPaperId: (val: string) => void; //设置试卷id
    lockEdit: boolean; // 禁止编辑
    topics: OrderTopicType[]; //题目
    examData: ExamListItem | null; //考核信息
    setTopics: (topics: OrderTopicType[]) => void; //设置题目
    addTopic: (type: QuestionType) => void; //添加题目
    loadPaperData: () => void; //更新题目列表
    loadExamPaperData?: () => void; //更新试卷列表
    examPaperData: ExamPaperListItem[]; //试卷列表
    examId: string; //考核id
    checked: number; //选中项
    setChecked: (val: number) => void; //设置选中
}

const PaperContext = React.createContext<PaperContextProps>({
    lockEdit: false,
    paperId: "",
    setPaperId: () => null,
    topics: [],
    examData: null,
    setTopics: () => null,
    addTopic: () => null,
    loadPaperData: () => null,
    loadExamPaperData: () => null,
    examPaperData: [],
    examId: "",
    checked: 0,
    setChecked: () => null
});

export default PaperContext;
